<div class="password-visibility"
     *ngIf="input.isPassword()"
     [class.visible]="input.nowPassword()"
     (click)="input.togglePasswordType()">
    <svg-icon src="/assets/icons/visibility.svg" focusable="false"></svg-icon>
    <svg-icon src="/assets/icons/visibility-off.svg"></svg-icon>
</div>
<ng-content></ng-content>
<div class="placeholder">{{input.placeholder}}</div>